/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { CosmosQuoteFragment } from "@cosmos/hygraph-schema";

export const cosmosElementQuote: CosmosQuoteFragment = {
	__typename: "CosmosElementQuote",
	quote:
		"What was your thought process in this challenge? How did the model of the Len Lye Centre, which is a building in New Plymouth, New Zealand play into your creation?",
	source: "Burning Glass Technologies",
	description:
		"Lorem ipsum dolor sit amet consectetur. Ornare urna malesuada bibendum urna vitae tincidunt.. Dignissim nisi nibh nec laoreet lobortis volutpat..",
};
